<div
  [class.vex-layout-scroll-disabled]="scrollDisabled$ | async"
  [class.vex-layout-sidenav-collapsed]="sidenavCollapsed$ | async"
  class="vex-base-layout-container vex-layout-horizontal vex-layout-toolbar-fixed">
  <ng-content></ng-content>
</div>
